import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "duration", "Wrapper"];
import { PlainWrapper, TwoWayTransition } from 'foundations-components/transitional/components/TwoWayTransition';
import { jsx as _jsx } from "react/jsx-runtime";
const slideAxis = align => align === 'top' || align === 'bottom' ? 'translateY' : 'translateX';
const slideDirection = align => align === 'bottom' || align === 'right' ? '(100%)' : '(-100%)';
function MobilePanelTransitionWrapper(props) {
  const {
    align = 'right',
    duration,
    open,
    transitionActive,
    transitioning
  } = props;
  return /*#__PURE__*/_jsx(PlainWrapper, Object.assign({}, props, {
    "data-component-name": "UIPanel",
    "data-open-complete": open && !transitioning,
    $wrapperCSSStyles: {
      transitionDuration: `${duration}ms`,
      transitionProperty: transitionActive ? 'transform' : 'none',
      transform: open ? `${slideAxis(align)}(0%)` : `${slideAxis(align)}${slideDirection(align)}`,
      position: 'fixed',
      top: 0,
      bottom: 0,
      zIndex: 1211,
      width: '100%'
    }
  }));
}
export default function MobilePanelTransition(_ref) {
  let {
      align = 'right',
      duration = 150,
      Wrapper = MobilePanelTransitionWrapper
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, rest, {
    duration: duration,
    align: align,
    Wrapper: Wrapper,
    transitionOnMount: true
  }));
}